Ext.define('SA.view.ToggleButton', {
    alias: 'widget.sa-toggle-button',
    extend: 'SA.view.Button',

    allowDepress: true,
    pressed: false,

    initComponent() {
        this.callParent();
        this.setPressed(this.pressed);
    },

    isPressed() {
        return this.pressed;
    },

    onClick() {
        if (!this.disabled) {
            if (this.allowDepress) {
                this.toggle();
            }
            else {
                this.setPressed(true);
            }

            this.callParent();
        }
    },

    setPressed(pressed) {
        this.pressed = pressed;

        this.ifCls(pressed, 'sa-button-pressed');
    },

    toggle() {
        this.setPressed(!this.isPressed());
    }
});